// Copyright 2017 Sorama B.V.

import { autoinject, bindable, child, customElement } from "aurelia-framework";

@customElement("validated-input")
@autoinject
export class ValidatedInput {
    //#region Bindable Properties
    @bindable
    public quantity: string;

    @bindable
    public valid = true;

    @bindable
    public reason: string;

    //#endregion

    //#region Private Properties
    @child("input") inputElement: HTMLInputElement;
    //#endregion

    //#region Constructor & Aurelia Callbacks
    public attached(): void {
        this.validChanged(this.valid, null);
    }
    //#endregion

    public validChanged(newValue: boolean, oldValue: boolean): void {
        if (!this.inputElement) return;

        if (newValue) {
            this.inputElement.setCustomValidity("");
        } else {
            this.inputElement.setCustomValidity(this.reason);
        }
    }
}
